import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, AbstractControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../api.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  queryParams: any;
  forGotPasswordForm: FormGroup;
  password: any;
  cpassword: any;
  isSubmitted: boolean = false;
  forGotPasswordResponse: any;
  errorMsg: string="";
  status:boolean = false;
  status2:boolean = false;
  passerr2= '';
  mode = '';

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private httpService: ApiService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.queryParams = params;
    });

    this.forGotPasswordForm = this.fb.group({
      password: ['', Validators.required],
      cpassword: ['', [Validators.required,checkConfirmPassword.bind(this)]]
    });
    function  checkConfirmPassword(control:AbstractControl):{passwordNotMatch:boolean}{
      let password:any = this.forGotPasswordForm?this.forGotPasswordForm['value']['password']:null;
      let confirmpassword:any = control.value; 
      if(confirmpassword && confirmpassword.length){
      if(password != control.value){
        return {passwordNotMatch:true};
       }else{
         return null;
       }
       }else{
         return null;
       }
      }
  }

  get f() {
    return this.forGotPasswordForm.controls;
  }
  updatePassword() {
    this.isSubmitted = true;
    if (this.forGotPasswordForm.invalid || !this.checkpasswordvalid(this.forGotPasswordForm.value.password)) {
      return;
    } else {
      this.mode = 'indeterminate';
        let Url = "user/change-password";
        let Data = { newPassword: this.forGotPasswordForm.value.password, token: this.queryParams['token'] ? this.queryParams['token'] : "token" };
        this.httpService.postFormData(Url, Data).subscribe(response => {
          this.mode = 'determinate';
          if (response.success == true) {
            // console.log(response['msg']);
            // this.errorMsg = response['msg'];
            location.href = "?loginUser=true"
          }
          if(response.success == false){
            this.errorMsg = response['msg'];
          }
        });
    }
  }

  checkpasswordvalid(str) {
    if(str !== '') {
      // console.log(str);
      // var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      var re = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z!#$%@_^&? "])[a-zA-Z0-9!#$%@_^&?]{6,}$/;
      // console.log(re.test(str));
      if (!re.test(str)){
        this.passerr2 = "Atleast 1 Digit, 1 UpperCase and 1 special Character is required.";
      } else {
        this.passerr2 = '';
      }

      return re.test(str);
    } else {
      this.passerr2 = '';
    }
  }

  showPass() {
    let x: any = document.getElementById("visibility1");
    // console.log(x, x.type);
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
    this.status = !this.status;
  }


  showPass2() {
    let y: any = document.getElementById("visibility2");
    if (y.type === "password") {
      y.type = "text";
    } else {
      y.type = "password";
    }
    this.status2 = !this.status2;
  }
  keyUp(event) {
    this.isSubmitted = false;
    this.errorMsg = "";
    // this.checkpasswordvalid(event.target.value);
  }
}
